import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import tools from './tools'

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$tools = tools;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
